/* eslint-disable no-unused-expressions */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable no-console */
/* eslint-disable import/prefer-default-export */

import { useEffect, useCallback, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import {
  resetSimActivationState,
  runSimActivationCheck,
  updateEpikBox,
} from '../../../../../../../actions/EpikBoxes';
import utils from '../../../../../../../lib/utils';

export const useFetchSimStatus = (sims, box) => {
  const dispatch = useDispatch();
  const simActivationCheckState = useSelector(
    state => state.AppState.boxDetails.simActivationCheck,
  );
  const { connection: data, error } = simActivationCheckState;

  const modemsArrayForCurrentBox = box?.modems;

  const phonesArrayStateForCurrentBox = useMemo(() => {
    if (!modemsArrayForCurrentBox.length) return [];
    const { 0: modem } = modemsArrayForCurrentBox;
    if (!modem.hasOwnProperty('phones')) return [];
    return !!data?.length
      ? data?.reduce((acc, curr) => {
          if (curr?.connection?.msisdn) acc.push(curr.connection.msisdn);
          return acc;
        }, [])
      : modem.phones;
  }, [simActivationCheckState, box]);

  const { lteIp: lteIpInState, lteIp2: lteIp2InState } = box;

  const fetchSimActivationStatus = useCallback(() => {
    dispatch(runSimActivationCheck(sims));
  }, [sims]);

  const showToastAndUpdateBoxDetails = useCallback(async () => {
    /* Show Toast */
    toast.success('Sim Status has been fetched successfully');

    /* Default State */
    let lteIpLocal = lteIpInState;
    let lteIp2Local = lteIp2InState;

    /* Updating Lte Values based on length of response data */
    switch (data.length) {
      case 1: {
        const { 0: vzwObject } = data;
        lteIpLocal = vzwObject?.ip || lteIpInState;
        break;
      }
      case 2: {
        const { 0: vzwObject, 1: tmoObject } = data;
        lteIpLocal = vzwObject?.ip || lteIpInState;
        lteIp2Local = tmoObject?.ip || lteIp2InState;
        break;
      }
      default:
        break;
    }

    /* updating box and updating it in database */
    if (data?.length) {
      const updatedlteIpStates = {
        ...box,
        lteIp: lteIpLocal,
        lteIp2: data.length === 2 ? lteIp2Local : lteIp2InState,
      };
      const updatedlteBoxModem = updatedlteIpStates?.modems[0];
      if (updatedlteBoxModem?.phones) {
        updatedlteIpStates.modems[0].phones = [...phonesArrayStateForCurrentBox];
      }

      const token = utils.getAuthToken();
      dispatch(await updateEpikBox(token, updatedlteIpStates));
    }
  }, [data, box, phonesArrayStateForCurrentBox]);

  useEffect(() => {
    if (typeof data === 'object' && data?.message) toast.info(data.message);
    if (!!data?.length) showToastAndUpdateBoxDetails();
    if (error) toast.error(error);
  }, [simActivationCheckState]);

  useEffect(
    () => () => {
      dispatch(resetSimActivationState());
    },
    [],
  );

  return { activationState: simActivationCheckState, fetchSimStatus: fetchSimActivationStatus };
};
